import { BASE_API_CONFIG } from "../../util/Api";
import { NETWORK_METHOD } from "../../util/ApiHelper";

export const MY_EXIM_API_OFFER_PRODUCTS = {
  createOfferProduct: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/offer-products`,
    data: params.data
  }),
  updateOfferProduct: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/offer-products/${params?.id}`,
    data: params.data
  }),
   getOfferProductsList: (params) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/offer-products?page=${params?.page}&limit=${params?.limit}`,
    params: {
      page: params.page,
      limit: params.limit
    }
  }),
   getOfferProductsListExporter: (params) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/offer-products/exporters?page=${params?.page}&limit=${params?.limit}`,
    params: {
      page: params.page,
      limit: params.limit
    }
  }),
    deleteOfferProduct:(param)=>({
    method: NETWORK_METHOD.DELETE,
    url:`${BASE_API_CONFIG.baseURL}/offer-products/${param?.id}`
  }),

    offerProductById: (param)=>({
    method:NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/offer-products/${param?.id}`
  }),
}
